<template>
  <div class="c-folder-rights">
    <header class="header">
      <div class="titleContainer">
        <div class="title-icon">
          <img src="../../assets/icons/permission-icon-ds.svg" :alt="'user-rights'">
        </div>
        <h1 class="title">{{ $t('folderRights.header.title') }} '{{ folderName }}'</h1>
      </div>
      <p4a-input
        class="searchBar"
        :type="'text'"
        :size="'small'"
        :placeholder="$t('folderRights.header.searchPlaceholder')"
        :closeInput="false"
        v-model.lazy="filterKey"
        :input-width="300"
        :leftIcon="'search'"/>
    </header>

    <section class="content">
      <div class="bodyText">
        <h3>{{ activeText.bodyTitle }}</h3>
        <div class="contentText">
          <p class="contentTextLine" v-for="(line, index) in activeText.bodyText" :key="index+100">{{ line }}</p>
        </div>
      </div>
        <table class="c-table">
          <thead>
            <tr>
              <th v-for="column in usersColumns" :key="column.columnHeader">
                <span v-if="column.columnHeader === 'Name'">{{ $t('folderRights.table.header.' + column.columnHeader + '.title') | capitalize }}</span>
                <span
                  v-else
                  class="tooltip top-tooltip"
                  @mouseover="updateActiveText(column)"
                  @mouseleave="restoreDefaultActiveText()"
                >
                  {{ column.columnHeader | capitalize }}
                  <span
                    class="tooltiptext"
                    :style="{
                      width: column.hoverText.length * 8 + 'px',
                      'margin-left': '-' + column.hoverText.length * 8/2 + 'px'
                    }"
                  >
                    {{ column.hoverText }}
                  </span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <p4a-button
              class="loading"
              v-if="isloading"
              :loading="true"
              :showIcon="true"
              :onlyIconVisible="false"
              :icon="'wait'"
              :product="'sns'"
              :size="'large'"
              :disable="false"
              :text="'Loading'"
            >
            </p4a-button>
            <virtual-list
              v-else
              class="tbodyContainer"
              :key="componentKey"
              :size="25"
              :remain="16"
              :start="0"
            >
              <tr v-for="user in filteredUsers" :key="user.PrivilegizedEntityId">
                <td v-for="column in usersColumns" :key="column.columnName">
                  <!-- Column with choices -->
                  <div class="checkboxContainerMain" v-if="isColumnData(column.columnName)">
                    <div class="checkboxContainer" v-if="user[column.columnName].Choices">
                      <input
                        type="checkbox"
                        @change="firstCheckmarkChanged(user, column.columnName)"
                        v-model.lazy="user[column.columnName].Choices[0]"
                        :indeterminate.prop="false"
                        :disabled="!modifyingMode">
                      <input
                        type="checkbox"
                        @change="secondCheckmarkChanged(user, column.columnName)"
                        v-model.lazy="user[column.columnName].Choices[1]"
                        :indeterminate.prop="isInderteminate(user[column.columnName].Choices, user[column.columnName].RightIsFromParent)"
                        :disabled="!modifyingMode">
                    </div>
                    <!-- Column with no choices (just one value {true or false}) -->
                    <div class="checkboxContainer" v-else>
                      <input v-if="column.columnName === 'ExtendedControl'"
                       type="checkbox"
                       v-model.lazy="user[column.columnName]"
                       :indeterminate.prop="isExtendedOrInformedInderteminate(user[column.columnName], user.ParentExtendedControl)"
                       :disabled="!modifyingMode || isExtendedControlDisabled(user)">
                      <input v-if="column.columnName === 'InformedFolder'"
                       type="checkbox"
                       v-model.lazy="user[column.columnName]"
                       :indeterminate.prop="isExtendedOrInformedInderteminate(user[column.columnName], user.ParentInformedFolder)"
                       :disabled="!modifyingMode || isInformControlDisabled(user, column, modifyingMode)">
                    </div>

                  </div>
                  <!-- Column Name -->
                  <p class="columnName tooltip top-left-tooltip top-tooltip" v-if="column.columnHeader === 'Name'">
                    <p4a-icon v-if="user.UserType === 0" :icon="'user'" />
                    <p4a-icon v-if="user.UserType === 1 && user.IsGroupDisabled === false" :icon="'group'" style="color: #DB8823" />
                    <p4a-icon v-if="user.UserType === 1 && user.IsGroupDisabled === true" :icon="'group'"/>
                    <template>{{user[column.columnHeader]}}</template>
                    <!-- activate tooltip on user names -->
                    <!-- <span v-if="user[column.columnHeader].length >= 34"
                      class="tooltiptext"
                    >
                      {{ user[column.columnHeader] }}
                    </span> -->
                  </p>
                </td>
              </tr>
            </virtual-list>
          </tbody>
        </table>
    </section>
    <footer class="buttons-row">
      <div>
        <p4a-button
          class="cancelButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="''"
          :size="'large'"
          :disable="!modifyingMode"
          :text="$t('folderRights.buttons.cancel')"
          @click="cancelChanges"
        ></p4a-button>
      </div>
      <div>
        <p4a-button
          class="removeAllRightsButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="''"
          :size="'large'"
          :disable="!modifyingMode"
          :text="$t('folderRights.buttons.removeAll')"
          @click="removeAllRights"
          v-if="canRemoveAllRights"
        ></p4a-button>
        <p4a-button
          class="exchangeButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="''"
          :size="'large'"
          :disable="modifyingMode"
          :text="$t('folderRights.buttons.exchange')"
          @click="showExchange"
        ></p4a-button>
        <p4a-button
          v-if="modifyingMode"
          class="modifyButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="'ds'"
          :size="'large'"
          :disable="false"
          :text="$t('folderRights.buttons.save')"
          @click="saveData"
        ></p4a-button>
        <p4a-button
          v-if="!modifyingMode"
          class="modifyButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="''"
          :size="'large'"
          :disable="false"
          :text="$t('folderRights.buttons.modify')"
          @click="activateModify"
        ></p4a-button>
        <p4a-button
          class="closeButton"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="'ds'"
          :size="'large'"
          :disable="modifyingMode"
          :text="$t('folderRights.buttons.close')"
          @click="closeWindow"
        ></p4a-button>
      </div>
    </footer>
  </div>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list'
import * as folderRightsApi from 'api/folderRightsApi'
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'
import * as settingsApi from 'api/settingsApi'

import Vue from 'vue'
import _ from 'lodash'

const UNLIMITEDUSER = 4
const CANREMOVEALLRIGHTS = 'RemoveAllRightsButton'

export default {
  components: { 'virtual-list': virtualList },
  data () {
    return {
      isloading: true,
      folderName: '',
      componentKey: 0,
      filterKey: '',
      activeText: {},
      modifyingMode: false,
      defaultText: {
        bodyTitle: this.$i18n.t('folderRights.table.header.Name.bodyTitle'),
        bodyText: this.$i18n.t('folderRights.table.header.Name.bodyText')
      },
      checkingUserObject: {
        'ExtendedControl': false,
        'InformedFolder': false,
        'ParentInformedFolder': false,
        'IT': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'BH': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'AS': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'IL': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'ET': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'EL': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'DL': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'EV': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'PC': { 'Choices': [ false, false ], 'RightIsFromParent': false },
        'PB': { 'Choices': [ false, false ], 'RightIsFromParent': false }
      },
      currentUserRights: {},
      rightSettings: [],
      $backupUsers: [],
      users: [],
      AlternativeText: this.$i18n.t('folderRights.table.header.Alternative.Default'),
      AlternativeFinalText: this.$i18n.t('folderRights.table.header.Alternative.DefaultFinal')
    }
  },
  created () {
    this.activeText = this.defaultText
    const id = this.$route.params.id

    let folderPermissionsLoaded = false
    let userLoaded = false
    let rightsLoaded = false

    folderRightsApi.getFolderName(id).then(name => {
      this.folderName = name
    })
    settingsApi.getUserLanguage().then(lang => {
      this.$root.$i18n.locale = lang
    })
    folderRightsApi.getFolderPermission(id).then(data => {
      folderPermissionsLoaded = true

      if (folderPermissionsLoaded && userLoaded && rightsLoaded) {
        this.isloading = false
      }
      this.$backupUsers = _.cloneDeep(data)
      this.users = data
    })
    usersAndGroupsApi.getcurrentuserrights().then(rights => {
      userLoaded = true

      if (folderPermissionsLoaded && userLoaded && rightsLoaded) {
        this.isloading = false
      }
      this.currentUserRights = rights
    })
    settingsApi.getRightsSettings().then(settings => {
      rightsLoaded = true

      if (folderPermissionsLoaded && userLoaded && rightsLoaded) {
        this.isloading = false
      }
      this.rightSettings = settings
    })

    settingsApi.getAlternativeTextSettings().then(settings => {
      this.AlternativeText = settings.alternativeApprove
      this.AlternativeFinalText = settings.alternativeFinal
    })
  },
  computed: {
    filteredUsers () {
      const filterKey = this.filterKey && this.filterKey.toLowerCase()
      const modifyingMode = this.modifyingMode
      const checkingUserObject = this.checkingUserObject
      let users = this.users
      if (!modifyingMode) {
        users = users.filter(function (user) {
          return _.isMatch(user, checkingUserObject) === false
        })
      }
      if (filterKey) {
        users = users.filter(function (user) {
          return String(user['Name']).toLowerCase().indexOf(filterKey) > -1
        })
      }
      return users
    },
    canRemoveAllRights () {
      if (_.find(this.currentUserRights.SystemRights, function (right) { return right === UNLIMITEDUSER }) &&
        this.rightSettings[CANREMOVEALLRIGHTS] === true) {
        return true
      }

      return false
    },
    usersColumns () {
      return [
        {
          columnName: 'Name',
          columnHeader: 'Name'
        },
        {
          columnName: 'IL',
          columnHeader: 'IL',
          hoverText: this.$i18n.t('folderRights.table.header.IL.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.IL.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.IL.bodyText')
        },
        {
          columnName: 'EL',
          columnHeader: 'EL',
          hoverText: this.$i18n.t('folderRights.table.header.EL.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.EL.bodyTitle'),
          bodyText: [this.$i18n.t('folderRights.table.header.Alternative.EL.bodyText', [this.AlternativeText])]
        },
        {
          columnName: 'DL',
          columnHeader: 'DL',
          hoverText: this.$i18n.t('folderRights.table.header.DL.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.DL.bodyTitle'),
          bodyText: [this.$i18n.t('folderRights.table.header.Alternative.DL.bodyText', [this.AlternativeText, this.AlternativeFinalText])]
        },
        {
          columnName: 'ET',
          columnHeader: 'ET',
          hoverText: this.$i18n.t('folderRights.table.header.ET.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.ET.bodyTitle'),
          bodyText: [
            this.$i18n.t('folderRights.table.header.Alternative.ET.bodyText1', [this.AlternativeText]),
            this.$i18n.t('folderRights.table.header.Alternative.ET.bodyText2'),
            this.$i18n.t('folderRights.table.header.Alternative.ET.bodyText3'),
            this.$i18n.t('folderRights.table.header.Alternative.ET.bodyText5', [this.AlternativeText]),
            this.$i18n.t('folderRights.table.header.Alternative.ET.bodyText6')
          ]
        },
        {
          columnName: 'AS',
          columnHeader: 'A',
          hoverText: this.$i18n.t('folderRights.table.header.A.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.A.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.A.bodyText')
        },
        {
          columnName: 'IT',
          columnHeader: 'IT',
          hoverText: this.$i18n.t('folderRights.table.header.IT.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.IT.bodyTitle'),
          bodyText: [
            this.$i18n.t('folderRights.table.header.Alternative.IT.bodyText1'),
            this.$i18n.t('folderRights.table.header.Alternative.IT.bodyText2'),
            this.$i18n.t('folderRights.table.header.Alternative.IT.bodyText3'),
            this.$i18n.t('folderRights.table.header.Alternative.IT.bodyText5', [this.AlternativeText])
          ]
        },
        {
          columnName: 'ExtendedControl',
          columnHeader: '+',
          hoverText: this.$i18n.t('folderRights.table.header.+.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.+.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.+.bodyText')
        },
        {
          columnName: 'EV',
          columnHeader: 'EV',
          hoverText: this.$i18n.t('folderRights.table.header.EV.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.EV.bodyTitle'),
          bodyText: [this.$i18n.t('folderRights.table.header.Alternative.EV.bodyText', [this.AlternativeFinalText])]
        },
        {
          columnName: 'BH',
          columnHeader: 'B',
          hoverText: this.$i18n.t('folderRights.table.header.B.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.B.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.B.bodyText')
        },
        {
          columnName: 'PB',
          columnHeader: 'PB',
          hoverText: this.$i18n.t('folderRights.table.header.PB.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.PB.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.PB.bodyText')
        },
        {
          columnName: 'PC',
          columnHeader: 'PC',
          hoverText: this.$i18n.t('folderRights.table.header.PC.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.PC.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.PC.bodyText')
        },
        {
          columnName: 'InformedFolder',
          columnHeader: 'I',
          hoverText: this.$i18n.t('folderRights.table.header.I.bodyTitle'),
          bodyTitle: this.$i18n.t('folderRights.table.header.I.bodyTitle'),
          bodyText: this.$i18n.t('folderRights.table.header.I.bodyText')
        }
      ]
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    isColumnData (columnName) {
      if (columnName === 'PrivilegizedEntityId' || columnName === 'UserType' || columnName === 'ParentInformedFolder' || columnName === 'ParentExtendedControl' || columnName === 'Name') {
        return false
      } else {
        return true
      }
    },
    getCheckboxes (columnData, columnName) {
      if (columnName === 'ExtendedControl' || columnName === 'InformedFolder') {
        return [columnData]
      } else if (columnData !== undefined) {
        return columnData.Choices
      }
    },
    isInderteminate (choices, parent) {
      if (choices[1] === false && parent === true) {
        return true
      } else {
        return false
      }
    },
    isExtendedOrInformedInderteminate (choice, parent) {
      if (choice === false && parent === true) {
        return true
      } else {
        return false
      }
    },
    isExtendedControlDisabled (user) {
      if (user['AS'].Choices[0] === true || user['IT'].Choices[0] === true) {
        return false
      } else {
        user['ExtendedControl'] = false
        return true
      }
    },
    isInformControlDisabled (user, column, modifyingMode) {
      if (column.columnName === 'InformedFolder') {
        if (user['IL'].Choices[0] === true || user['EL'].Choices[0] === true ||
        user['DL'].Choices[0] === true || user['ET'].Choices[0] === true ||
        user['AS'].Choices[0] === true || user['IT'].Choices[0] === true ||
        user['EV'].Choices[0] === true || user['BH'].Choices[0] === true ||
        user['PB'].Choices[0] === true || user['PC'].Choices[0] === true) {
          return false
        } else {
          user['InformedFolder'] = false
          return true
        }
      } else {
        return !modifyingMode
      }
    },
    firstCheckmarkChanged (user, selectedColumn) {
      if (user[selectedColumn].Choices[0] === false) {
        user[selectedColumn].Choices[1] = false
      }
    },
    secondCheckmarkChanged (user, selectedColumn) {
      if (user[selectedColumn].Choices[1] === true) {
        user[selectedColumn].Choices[0] = true
      }
    },
    updateActiveText (column) {
      this.activeText = column
    },
    restoreDefaultActiveText () {
      this.activeText = this.defaultText
    },
    activateModify () {
      this.modifyingMode = !this.modifyingMode
    },
    showExchange () {
      const url = window.location.origin + '/UserControls/Management/ChangeRoles.aspx'
      const w = 501
      const h = 470
      // het midden bepalen
      const leftPos = (screen.width) ? (screen.width - w) / 2 : 0
      const topPos = (screen.height) ? (screen.height - h) / 2 : 0
      // instellingen in een string zetten
      const windowOpenSettings = 'width=' + w + 'px, height=' + h + 'px, left=' + leftPos + 'px, top=' + topPos + 'px, resizable=yes, modal=yes, dependent=yes, dialog=yes, alwaysRaised=yes'
      let child = window.open(url, '_blank', windowOpenSettings) // _blank opens a new window!
      child.opener = window
      // let timer = setInterval(checkChild, 500)
      // function checkChild () {
      //   if (child.closed) {
      //     location.reload()
      //     clearInterval(timer)
      //   }
      // }
    },
    removeAllRights () {
      if (!this.canRemoveAllRights) {
        return
      }
      var self = this

      _.forEach(self.users, function (user) {
        _.forEach(self.usersColumns, function (column) {
          if (self.isColumnData(column.columnName)) {
            if (user[column.columnName].Choices) {
              if (user[column.columnName].Choices[0]) {
                Vue.set(user[column.columnName].Choices, '0', false)
              }
              if (user[column.columnName].Choices[1]) {
                Vue.set(user[column.columnName].Choices, '1', false)
              }
            } else if (user[column.columnName]) {
              Vue.set(user, column.columnName, false)
            }
          }
        })
      })
    },
    closeWindow () {
      window.close()
    },
    cancelChanges () {
      this.users = _.cloneDeep(this.$backupUsers)
      this.modifyingMode = !this.modifyingMode
      this.componentKey += 1
    },
    saveData () {
      const users = this.users
      this.$backupUsers = _.cloneDeep(users)
      const id = this.$route.params.id
      folderRightsApi.saveFolderPermission(id, users).then(data => {
        this.modifyingMode = !this.modifyingMode
        this.componentKey += 1
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/folder/folderRights.vue